module.exports = __webpack_public_path__ + "img/p4-p1-text.97769a8c.png";